module.exports = __webpack_public_path__ + "static/editor_evolution-e1bf722bbd1b53269715431970d5c645.png";